import { Button } from "@loot-os/ui/components/button";

/** The foot of a cursor-paginated table; renders nothing once the last page is in. */
export function LoadMoreButton({
  hasNextPage,
  isFetchingNextPage,
  onClick,
}: {
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  onClick: () => void;
}) {
  if (!hasNextPage) return null;
  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className="self-center"
      disabled={isFetchingNextPage}
      onClick={onClick}
    >
      {isFetchingNextPage ? "Loading…" : "Load more"}
    </Button>
  );
}
